import { render, staticRenderFns } from "./AddSquawk.vue?vue&type=template&id=4ec16caa&scoped=true"
import script from "./AddSquawk.vue?vue&type=script&lang=js"
export * from "./AddSquawk.vue?vue&type=script&lang=js"
import style0 from "./AddSquawk.vue?vue&type=style&index=0&id=4ec16caa&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4ec16caa",
  null
  
)

export default component.exports